// actions.js
export const increment = () => ({
  type: 'INCREMENT',
});

export const decrement = () => ({
  type: 'DECREMENT',
});

export const updateFilterData = (filterdata) => ({
  type: 'UPDATE_FILTER_DATA',
  payload: filterdata,
});

export const setLocations = (locations) => ({
  type: 'SET_LOCATION_ITEMS',
  payload: locations,
});

export const setProducts = (products) => ({
  type: 'SET_PRODUCT_ITEMS',
  payload: products,
});

export const setPeriods = (periods) => ({
  type: 'SET_PERIOD_ITEMS',
  payload: periods,
});
export const setProductAtt = (productAtt) => ({
  type: 'SET_PRODUCT_ATTRIBUTE',
  payload: productAtt,
});
export const setLocationAtt = (locationAtt) => ({
  type: 'SET_LOCATION_ATTRIBUTE',
  payload: locationAtt,
});
export const setFilterPost = (filter) => ({
  type: 'SET_FILTER_POST',
  payload: filter,
});